import { NoticeItemInterface } from '@api/announcement/type';
import {
  createProject,
  delProject,
  projectDetail,
  updateProject
} from '@api/project';
import { PROJECT_MODE } from '@components/ProjectFromComponents/data';
import RevertModal from '@components/revertModal';
import ZeissTable from '@components/table';
import type { TableProps } from 'antd';
import { Form, Input, Space, message } from 'antd';
import { useEffect, useState } from 'react';
import { useImmer } from 'use-immer';
import { CreateProject } from '../../../../../../components/ProjectFromComponents/CreateProject';
import { Project_COLUMNS } from './data';
import './index.scss';
const { TextArea } = Input;

interface RecordData {
  username?: string;
  email?: string;
  phone?: string;
  userId?: string;
  subjectMatterCode?: string;
  noticeProjectCode?: string;
  subjectMatterProjectCode?: string;
  checkNeedOperation: () => any;
}

export const useProjectTable = ({
  details,
  getAnnInfo,
  dict,
  systemCity,
  isFinishAction,
  isReturnAction,
  checkNeedOperation
}: any) => {
  const [data, setData] = useImmer([]);
  const [delId, setDelId] = useState('');
  const [open, setOpen] = useState(false);
  const [recordData, setRecordData] = useState<any>({});
  const [delOpen, setdelOpen] = useState(false);
  const [form] = Form.useForm();

  //显示删除框
  const handleClickDel = async (id: string) => {
    const isNeedOperation = await checkNeedOperation?.();
    if (!isNeedOperation) return;
    setdelOpen(true);
    setDelId(id);
  };

  const handleOk = async (data: NoticeItemInterface) => {
    data?.subjectMatterProjectCode
      ? await updateProject({
          ...data,
          subjectMatterProject: true
        })
      : await createProject({
          ...data,
          subjectMatterProject: true
        });
    setOpen(false);
    form.resetFields();
    await getAnnInfo();
  };

  //修改
  const handleProject = async (record: RecordData) => {
    const isNeedOperation = await checkNeedOperation?.();
    if (!isNeedOperation) return;
    const res = await getDetail(record?.noticeProjectCode ?? '');
    setRecordData(res);
    setOpen(true);
  };

  const getDetail = async (noticeProjectCode: string) => {
    const res = await projectDetail({
      noticeProjectCode
    });
    return res;
  };

  const columns: TableProps<any>['columns'] = [...Project_COLUMNS];

  columns.push({
    title: '操作',
    key: 'action',
    width: 150,
    fixed: 'right',
    align: 'center',
    render: (record: RecordData) => {
      if (!isReturnAction) {
        return (
          <Space size={'middle'}>
            <a onClick={() => handleProject(record)}>编辑</a>
            <div
              className="pc-roleAdmin-del"
              onClick={() => handleClickDel(record?.noticeProjectCode || '')}
            >
              删除
            </div>
          </Space>
        );
      }
    }
  });

  const deleteAccount = async () => {
    try {
      const val = await form.validateFields();
      await delProject({
        noticeProjectCode: [delId],
        subjectMatterProject: true,
        ...val
      });
      setdelOpen(false);
      message.success('删除成功!');
      getAnnInfo();
    } catch (e) {
      console.log(e);
    }
  };

  const handleCancel = () => {
    setRecordData({});
  };

  useEffect(() => {
    setData(details.projects ?? []);
  }, [details]);

  const projectTableComponent = (
    <>
      {!data?.length ? (
        ''
      ) : (
        <div className="pc-sub-container">
          <div className="pc-table-wrap">
            {data.map((item: any) => {
              return (
                <div className="pc-table-item" key={item.baseSubjectMatterCode}>
                  <div className="pc-sub-tit">
                    <div>【项目】{item.projectName}</div>
                  </div>

                  <ZeissTable
                    columns={columns}
                    dataSource={[item]}
                    bordered={false}
                    scroll={{ x: 1700 }}
                    // onChange={handleChange}
                    pagination={false}
                  />
                </div>
              );
            })}
          </div>

          <CreateProject
            mode={PROJECT_MODE.EDIT}
            title={recordData.projectName}
            formRef={form}
            noticeRecord={details}
            record={recordData}
            handleOk={handleOk}
            open={open}
            setOpen={setOpen}
            dicList={dict}
            systemCity={systemCity}
            handleCancel={handleCancel}
          />

          <RevertModal
            title="确认删除该项目？"
            open={delOpen}
            onCancel={() => setdelOpen(false)}
            onConfirm={deleteAccount}
          >
            <Form form={form} layout="vertical" style={{ marginTop: 20 }}>
              <Form.Item
                label={'备注：'}
                name={'remark'}
                rules={[{ required: true }]}
              >
                <TextArea placeholder="输入备注内容" rows={3} />
              </Form.Item>
            </Form>
          </RevertModal>
        </div>
      )}
    </>
  );

  return {
    projectTableComponent
  };
};
